/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {FolderListPageComponent} from './folder-list-page.component';

@Component({
  standalone: true,
  imports: [FolderListPageComponent],
  selector: 'adn-folder-route-page',
  template: `
    <adn-folder-list-page
      [readOnly]="readOnly">
    </adn-folder-list-page>
  `
})
export class FolderRoutePageComponent {
  @Input() readOnly = false;
}
